module.exports = __webpack_public_path__ + "static/assets/c4cfeba031793d2422ed697cc3d4db88.png";